// extracted by mini-css-extract-plugin
export default {"header":"jhohU","header__close":"__Rgu","header__title":"ByW_Y","header__extra":"hO6kE","appear-from-above":"ugQcp","appearFromAbove":"ugQcp"};